module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh_cn":{"publish":"发布","guidesListEmpty":"暂时没有符合条件的导览"},"zh_hk":{"publish":"發布","guidesListEmpty":"暫時沒有符合條件的導覽"},"en":{"publish":"publish","guidesListEmpty":"There are currently no eligible tours"},"ja":{"publish":"リリース","guidesListEmpty":"現在対象のツアーはありません"}}')
  delete Component.options._Ctor
}
